export enum EMatchOutcome {
	WIN = "WIN",
	DRAW = "DRAW",
	LOSS = "LOSS",
	UNKNOWN = "UNKNOWN"
}
